// extracted by mini-css-extract-plugin
module.exports = {"header":"PopularTags_header__ljzZT","list":"PopularTags_list__ktfx4","extraRight":"PopularTags_extraRight__d36RB"};